var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateBookingExisting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.6,145.9c19.1,28.5,30.4,52.5-11.5,80.6c-19,12.8-29.8,14.6-41.1,13.6l-0.7,0c-1.2,0.1-2.3,0-3.5-0.2 l-74.2-14.3c-9.7-1.9-12.2-12.2-10.9-18.8c0.7-3.3,3.2-6.7,6.5-9c3.3-2.2,7.1-3.1,10.5-2.5l27.2,5.3l-47.6-70.9 c-4.4-6.6-2.6-15.6,4-20c6.5-4.4,15.1-2.5,19.6,4.2l15.1,22.6l0-0.1l15.6,23.2c1.4,2.1,4.3,2.7,6.5,1.3s2.7-4.3,1.3-6.5l-18.1-27 c0.9-1.1,1.9-2.1,3.2-2.9c5-3.3,11.3-3.1,16.3,0.7l1.4,1.1l17.1,25.4c1.4,2.1,4.3,2.7,6.5,1.3s2.7-4.3,1.3-6.5l-17.4-26 c1-1.2,2.1-2.5,3.4-3.3c5-3.3,11.3-3.1,16.3,0.7l0.8,0.6l17.1,25.4c1.4,2.1,4.3,2.7,6.5,1.3c2.1-1.4,2.7-4.3,1.3-6.5l-16.9-25.2 c0.9-1.3,2-2.5,3.6-3.6c6.5-4.4,14.9-2.5,19.4,4.3L232.6,145.9L232.6,145.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,107.1c-3.9,0-7.2,4.6-7.2,10.3c0,5.6,3.2,10.3,7.2,10.3h15.1c-2.3-6.9-1.2-14.5,2.6-20.6H59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,158.3H94l-13.6-20.6H59.6c-3.9,0-7.2,4.6-7.2,10.3S55.6,158.3,59.6,158.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.6,188.9h30.5c5.4-3.4,11.5-4.6,17.4-3.5l5.2,1.1l-12-18.1H59.6c-3.9,0-7.2,4.6-7.2,10.3 C52.4,184.3,55.6,188.9,59.6,188.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,234.7c-4.3-0.9-7.8-2.7-10.6-5.2H42.1c-10.5,0-10.2-10.2-10.2-10.2V56c0,0-0.4-10.2,10.2-10.2 c5.4,0,2.8,0,10.2,0V56c0,0.8,0.4,10.2,10.2,10.2h81.7c9.9,0,10.2-9.9,10.2-10.2c0-3.7,0.3-5.5,0.3-10.3c12,0,9.9,0.1,9.9,0.1 s10.9,0.2,10.9,9.8c0,10.6,0,28.8-0.1,49.1c1.5,0.4,3,0.9,4.4,1.5c0.3-0.1,0.6-0.2,0.8-0.2c1.5-1.9,3.2-3.5,5.3-4.9 c3-2,6.1-3.2,9.3-3.8V56c0-19.9-11.3-30.6-30.6-30.6h-10.2c0,0.1,0-6.5,0-10.2c0-0.1-0.3-10.2-10.2-10.2H62.5 c-10,0-10.2,10.7-10.2,10.2v10.2c-6.6,0-10.2,0-10.2,0c-20.3,0-30.6,10.7-30.6,30.6v163.4c0,19.9,10.3,30.6,30.6,30.6h122.6 c2.3,0,4.5-0.2,6.5-0.5L97.3,234.7z M72.8,25.4h61.3v20.5H72.8V25.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateBookingExisting);
export default __webpack_public_path__ + "static/media/create_booking-existing.f46b627a5ac4bc296281706caf0e9564.svg";
export { ForwardRef as ReactComponent };